import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  GoogleMapDefinition,
  GoogleMapProps,
  GoogleMapsPlatformProps,
} from '../GoogleMap.types';
import { props as viewerPropsMapper } from './GoogleMap.mapper';

const props = composeMapper<
  PreviewWrapperProps<GoogleMapProps>,
  GoogleMapDefinition,
  GoogleMapsPlatformProps
>()(
  viewerPropsMapper,
  { add: ['shouldResetComponent'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    return {
      ...viewerProps,
      previewWrapperProps: {
        shouldResetComponent: deps.shouldResetComponent,
      },
    };
  },
);
export default createComponentPreviewMapperModel({
  props,
});
